import type { TableColumn } from '@consta/uikit/Table'
import { Table } from '@consta/uikit/Table'
import type { FC } from 'react'

import type { TraceHeaderRowType } from '../segyHelpers'
import css from './Setup.css'

type TraceRowType = {
  position: string
  id: string
  description: string
  [key: string]: string
}

const commonColumnsTraceHeader: TableColumn<TraceRowType>[] = [
  {
    title: 'POS',
    accessor: 'position',
    align: 'right',
    width: 65,
  },
  {
    title: 'NAME',
    accessor: 'description',
    width: 210,
  },
]

export const TraceHeaderTable: FC<{
  traceHeaders?: TraceHeaderRowType[][]
}> = ({ traceHeaders }) => {
  const columnsTraceHeader = [
    ...commonColumnsTraceHeader,
    ...(traceHeaders?.map((_, index) => ({
      title: `${index + 1}`,
      accessor: `${index}`,
      width: 65,
    })) ?? []),
  ]

  const convertedTraceHeaders: TraceRowType[] = []
  const firstTraceHeaders = traceHeaders?.[0]
  if (firstTraceHeaders) {
    for (let rowNum = 0; rowNum < firstTraceHeaders.length; ++rowNum) {
      const newRow: TraceRowType = {
        id: firstTraceHeaders[rowNum]?.description ?? '',
        position: (firstTraceHeaders[rowNum]?.position + 1).toString(),
        description: firstTraceHeaders[rowNum]?.description ?? '',
      }
      for (let colNum = 0; colNum < traceHeaders.length; ++colNum) {
        newRow[`${colNum}`] = traceHeaders[colNum]?.[rowNum]?.value?.toString() ?? ''
      }
      convertedTraceHeaders.push(newRow)
    }
  }
  return (
    <Table
      className={css.codeFrameTraceHeaders}
      rows={convertedTraceHeaders}
      columns={columnsTraceHeader}
      zebraStriped="odd"
      getCellWrap={() => 'break'}
      size="m"
      stickyHeader={true}
      stickyColumns={2}
    />
  )
}
